import { render, staticRenderFns } from "./BillAttachModal.vue?vue&type=template&id=52cdbba4&scoped=true"
import script from "./BillAttachModal.vue?vue&type=script&lang=js"
export * from "./BillAttachModal.vue?vue&type=script&lang=js"
import style0 from "./BillAttachModal.vue?vue&type=style&index=0&id=52cdbba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdbba4",
  null
  
)

export default component.exports